import { BrutalistBadge, GlassCard, SolidBlock } from "@/app/components/brand-scaffold";

export function HomepageOpenSource() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20 bg-black/[0.04]">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-white" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white">
            APACHE-2.0
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-8">
          开源边界
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          <SolidBlock bgClass="bg-[#A3E635] text-black" className="!p-6">
            <h3 className="font-black text-lg mb-4">你可以</h3>
            <ul className="space-y-2">
              {canDo.map((item) => (
                <li key={item} className="text-sm text-zinc-900 flex items-start gap-2">
                  <span className="font-black">✓</span> {item}
                </li>
              ))}
            </ul>
          </SolidBlock>
          <SolidBlock bgClass="bg-[#8B5CF6] text-white" className="!p-6">
            <h3 className="font-black text-lg mb-4">官方运营层</h3>
            <ul className="space-y-2">
              {officialLayer.map((item) => (
                <li key={item} className="text-sm text-white/90 flex items-start gap-2">
                  <span className="text-white/60">→</span> {item}
                </li>
              ))}
            </ul>
          </SolidBlock>
        </div>
      </div>
    </section>
  );
}

const canDo = [
  "本地运行完整链路",
  "包装自己的能力为 Hotline",
  "自托管私有 catalog",
  "基于协议做二次开发",
  "在企业或研究环境中复现完整链路",
];

const officialLayer = [
  "官方 Marketplace 公共发现",
  "托管运营与 SLA",
  "未来结算网络与法币提现",
  "公共信誉与评分系统",
];
